import { emailValidator, isEmptyInputValue } from '@acme/b2c/validators';
import angular from 'angular';

/**
 * Service: validate
 *
 * This service accepts an Array of { key: value } pairs where
 * the key == validatorName
 */

export const ValidateServiceModule = angular.module('acme.common.service.validate', [])
.service('ValidateService', [ '$log', function($log) {

  /**
   * Validate if the arg is a possible URL
   * @param value
   * @returns {boolean} if it is url, returns true otherwise false
   */
    function isURL(value) {
      if ((/((https?|ftp):\/\/)|(mailto:\s*)/i).test(value)) {
        return true;
      }

      if((/\S\.[a-z]{2,40}/i).test(value) === false) {
        return false;
      }

      // jQuery Url Validation with optional protocol http:// and mailto:
      // https://github.com/jquery-validation/jquery-validation/blob/master/src/additional/url2.js
      return value.split(/\s+|:/)
          .map(function(val){
            return (/^(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i).test( val );
          })
          .filter(function(regexResult) {
            return regexResult !== false;
          }).length > 0;
    }

    return {

      init: function() {
        return true;
      },

      /**
       * Validate against an Array of Objects
       * Key must be the name of the validator
       *
       * @param list {Array}
       * @returns {boolean}
       */
      validate: function(list) {
        var i, ii,
            key,
            keys,
            validatorName,
            validatorValue,
            validatorFunc,
            customMessage;

        // Clear errors
        this.errors = [];

        this.passed = [];

        // Validate each element against its validator
        for (i=0,ii=list.length;i<ii;i++) {
          keys = [];
          validatorFunc = false;
          customMessage = false;
          validatorName = false;
          validatorValue = false;

          for (key in list[i]) {
            if (list[i].hasOwnProperty(key)) {
              // If there is a field continue on and skip adding to keys array
              // We need this for when we respond to link back to originating field
              if (key === 'field') { continue; }
              // Only grab first key in object as it should be the validatorName
              keys.push(key);
              break;
            }
          }

          if (keys.length === 1) {
            // Expect the validator to be the first KEY in the array
            validatorName = keys[0];

            if (list[i][validatorName]) {

              // Get validator and give it the value
              if (list[i][validatorName].hasOwnProperty('message')) {
                customMessage = list[i][validatorName].message;
                if (list[i][validatorName].hasOwnProperty('test')) {
                  if (typeof(list[i][validatorName].test) === 'function') {
                    validatorValue = list[i][validatorName].test();
                  }else{
                    validatorValue = list[i][validatorName].test;
                  }
                }else{
                  validatorValue = false;
                  this.errors.push({
                    validator: validatorName,
                    message: 'No test to run for validator `' + validatorName + '`'
                  });
                }
              }else{
                validatorValue = list[i][validatorName];
              }

            }

            validatorFunc = this.getValidator(validatorName);

            // If there is a validator and it fails
            if (validatorFunc && !validatorFunc(validatorValue)) {
              $log.info('Invalid `' + validatorName + '`');
              this.errors.push({
                validator: validatorName,
                message: (customMessage) ? customMessage : 'Invalid `' + validatorName + '`',
                payload: list[i]
              });
            }else if (!validatorFunc) {
              // If the function is not found add an error
              this.errors.push({
                validator: validatorName,
                message: 'No validator `' + validatorName + '` exists',
                payload: list[i]
              });
            }else{
              this.passed.push(list[i].field);
            }
          }else{
            this.errors.push({
              validator: false,
              message: 'Validator not found.',
              payload: list[i]
            });
          }

        }

        return (this.errors.length === 0);

      },

      /**
       * Get validator function
       *
       * @param name
       * @returns {boolean}
       */
      getValidator: function(name) {
        var validator;

        if (this.validators.hasOwnProperty(name)) {
          validator = this.validators[name];
        }

        return validator;
      },

      getError: function(fieldName) {

        var i, ii,
            r = false;

        for (i=0,ii=this.errors.length;i<ii;i++) {
          if (this.errors[i].hasOwnProperty('payload') && this.errors[i].payload.field === fieldName) {
            r = this.errors[i];
            break;
          }
        }

        return r;

      },

      getErrorHash: function() {

        var i, ii,
            r = {};

        for (i=0,ii=this.errors.length;i<ii;i++) {
          if (this.errors[i].hasOwnProperty('payload')) {
            r[this.errors[i].payload.field] = this.errors[i];
          }
        }

        return r;

      },

      validators: {
        /**
         * Email validation function
         */
        email: function (value: string) {
          return emailValidator(value);
        },

        /**
         * Optional email validation function
         */
        optionalEmail: function (value: string) {
          if (isEmptyInputValue(value)) {
            return true;  // don't validate empty values to allow optional controls
          }

          return emailValidator(value);
        },

        /**
         * Password validation
         *
         * @param value {String}
         */
        password: function (value) {
          return (value && value.length >= 4);
        },

        /**
         * Name String validation
         * Validate strings such as first, middle and last name
         *
         * @param value {String}
         */
        name: function (value) {
          var valid = false,
              testValue = (value) ? value : '';

          // Names should not begin with numbers
          if ((/[a-zA-Z\s]+/).test(testValue) &&
              (/^[\d]+/g).test(testValue) === false) {
            valid = true;
          }

          return valid;

        },

        /**
         * No malicious HTML tags validation
         *
         * @param prop
         * @returns {boolean}
         */
        safeInput: function (prop) {
          var value  = prop || "";

          if (typeof prop === "object" && prop && prop.value) {
            value = prop.value || "";
          }

          return (/[<>]/).test(value) === false && isURL(value) === false;
        },

        /**
         * No malicious HTML tags validation
         * No empty string
         *
         * @param prop
         * @returns {boolean}
         */
        safeInputLen: function (prop) {
          var value  = prop || "";
          var minLength = 1;

          if (typeof prop === "object" && prop && prop.value) {
            value = prop.value || "";

            minLength = parseInt(prop.minLength, 10) || 1;
          }

          return (/[<>]/).test(value) === false && value.length >= minLength && isURL(value) === false;
        },

        /**
         * Numeric validation
         * @param value {String}
         */
        number: function (value) {
          return !isNaN(parseFloat(value)) && isFinite(value);
        },

        /**
         * Zip Code validation
         * @param value {String|Number}
         */
        zip: function (value) {
          var valid = false,
              testValue = (value) ? value : '';

          if ((/^\d{5}(-\d{4})?$/).test(testValue)) {
            valid = true;
          }

          return valid;
        },

        /**
         * Zip Code Validation
         * @param {Object} props
         * @returns {Boolean}
         */
        zipcode: function(props) {
          var value = props.value || '';
          var country = props.country || '';
          var required = props.required || false;
          var valid = false;
          var regex: RegExp;

          switch (country.toLowerCase()) {
            case 'canada': regex = new RegExp('^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] +[0-9][A-Z][0-9]$', 'g'); break;
            default: regex = new RegExp('^\\d{5}(-\\d{4})?$');
          }

          valid = (
            (!required && !value.length) ||
            (required && value.length && !country.length) || 
            (regex.test(value))
          );

          return valid;
        },

        /**
         * Greater than validation with optional equalTo
         *
         * Accepts:
         * {
         *   greater: {*}
         *   less: {*}
         *   equalTo: (optional) {boolean}
         * }
         * @param props
         * @returns {boolean}
         */
        greater: function(props) {
          var r = false;

          if (props.equalTo) {
            r = (props.greater >= props.less);
          }else{
            r = (props.greater > props.less);
          }

          return r;
        },

        /**
         * Less than validation with optional equalTo
         *
         * Accepts:
         * {
         *   greater: {*}
         *   less: {*}
         *   equalTo: (optional) {boolean}
         * }
         * @param props
         * @returns {boolean}
         */
        less: function(props) {
          var r = false;

          if (props.equalTo) {
            r = (props.greater <= props.less);
          }else{
            r = (props.greater < props.less);
          }

          return r;
        },
        /**
         * Phone values
         *
         * @param value
         * @returns {boolean}
         */
        phone: function (value) {
          var stripped = (value) ? value.replace(/\D+/g, '') : '',
              valid = false;

          if ((/[<>]/).test(value) === false && (/^\d{9,25}$/).test(stripped)) {
            valid = true;
          }

          return valid;
        },

        /**
         * Equal values with no type coercion
         *
         * Accepts:
         * [ value1, value2 ]
         *
         * @param values {Array}
         * @returns {boolean}
         */
        equal: function(values) {
          return values[0] === values[1];
        },

        /**
         * Non Equal Values
         *
         * Accepts:
         * [ value1, value2 ]
         *
         * @param values
         * @returns {*}
         */
        notEqual: function(values) {
          return this.equal(values) === false;
        },

        /**
         * OR validator for values
         *
         * Accepts:
         * {
         *   values: {Array}
         *   expected: {String|Number|boolean}
         * }
         * @param props
         * @returns {boolean}
         */
        or: function(props) {
          var i, ii,
              r = false;

          if (props.values && props.values instanceof Array && props.hasOwnProperty('expected')) {
            for (i = 0, ii = props.values.length; i < ii; i++) {
              if (props.values[i] === props.expected) {
                r = true;
                break;
              }
            }
          }

          return r;

        },

        /**
         * Promo code validator
         * any alphanumeric that may or may not be separated by dashes
         * @param props
         * @returns {boolean}
         */
        promo: function(props) {
          var r = new RegExp(/^([a-zA-Z0-9]+)((-[a-zA-Z0-9])?([a-zA-Z0-9])*)+$/),
              code = props.code ? props.code + '' : '';
          return r.test(code);
        },

        /**
         * coupon code validator
         *
         * @param props
         * @returns {boolean}
         */
        coupon: function(props) {
          var r = new RegExp(/^(.)+$/);
          return r.test(props.code+'');
        },

        /**
         * Ensures strings are not empty
         *
         * Accepts:
         * {
         *   value: {String}
         *   minLength: {Integer}
         * }
         * @param props {Object}
         * @returns {boolean}
         */
        len: function(props) {
          var minLength = parseInt(props.minLength, 10) || 1;
          return (typeof(props.value) === 'string' && props.value.length > minLength - 1);
        }
      },

      // Error Array
      errors: []

    };

}]).name;